import React from "react";

const Label = ({ field, handleFieldChanged, type, value, showSimplifiedOptions }) => {
  /* console.log("**** field ****", field);
  console.log("showSimplifiedOptions", showSimplifiedOptions); */
  return (
    <div
      className={field.hasOwnProperty("col") && field.col ? "cell medium-" + field.col : "medium-12 cell"}
      key={field._uid}
    >
      <div>
        <label
          htmlFor={field._uid}
          style={{ margin: "16px 0", paddingBottom: "4px", fontSize: "16px" /* borderBottom: "1px solid #cacaca" */ }}
        >
          {field.hasOwnProperty("label") && field.label && Array.isArray(field.label) && field.label.length > 0 ? (
            field.label.map((v, i) => {
              return <p style={{ marginBottom: "0" }}>{v}</p>;
            })
          ) : (
            <p>{field.label}</p>
          )}

          {field.hasOwnProperty("boldLabel") &&
          field.boldLabel &&
          Array.isArray(field.boldLabel) &&
          field.boldLabel.length > 0 ? (
            field.boldLabel.map((v, i) => {
              return (
                <p style={{ margin: "0" }}>
                  <b>{v}</b>
                </p>
              );
            })
          ) : (
            <p>
              <b>{field.boldLabel}</b>
            </p>
          )}

          {field.hasOwnProperty("notes") && field.notes && Array.isArray(field.notes) && field.notes.length > 0 ? (
            field.notes.map((v, i) => {
              return <p style={{ margin: "7px 0", fontSize: "15px" }}>{v}</p>;
            })
          ) : (
            <p>
              <b>{field.notes}</b>
            </p>
          )}

          {field.hasOwnProperty("boldNotes") &&
          field.boldNotes &&
          Array.isArray(field.boldNotes) &&
          field.boldNotes.length > 0 ? (
            field.boldNotes.map((v, i) => {
              return <p style={{ marginBottom: "0" }}>{v}</p>;
            })
          ) : (
            <p style={{ marginTop: "7px", fontSize: "14px" }}>
              <b>{field.boldNotes}</b>
            </p>
          )}
        </label>
      </div>
    </div>
  );
};

export default Label;
